import { useState, useEffect } from "react";
import { EChartsOption } from "echarts-for-react";
import { localeDate } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import SimpleListbox from "../../../../components/input/SimpleListbox";
import { TraitChartFilter, TraitScoreEChart } from "../../course/performance/TraitScoreChart";
import {
	EssayTraitScoreViewModel,
	EssayTraitScoreWithNormsViewModel,
} from "./performanceReportApiSlice";

export const essayTraits: TraitChartFilter[] = [
	{ value: "totalScore", label: "Total Score", maxValue: 30 },
	{ value: "developmentOfIdeasScore", label: "Development of Ideas", maxValue: 5 },
	{ value: "organizationScore", label: "Organization", maxValue: 5 },
	{ value: "styleScore", label: "Style", maxValue: 5 },
	{ value: "wordChoiceScore", label: "Word Choice", maxValue: 5 },
	{ value: "sentenceStructureScore", label: "Sentence Fluency", maxValue: 5 },
	{ value: "conventionsScore", label: "Conventions", maxValue: 5 },
	{ value: "textualEvidenceScore", label: "Textual Evidence", maxValue: 3 },
	{ value: "contentAccuracyScore", label: "Content Accuracy", maxValue: 3 },
];

export const essayOptions = essayTraits.map((t) => ({ value: t.value, label: t.label }));

export function EssayTraitScoreChart(props: {
	className?: string;
	scores: EssayTraitScoreWithNormsViewModel[];
	averages: EssayTraitScoreViewModel;
}) {
	const getData = (filter: TraitChartFilter) => {
		const data = props.scores.map((data) => {
			const value = data[filter.value as keyof EssayTraitScoreWithNormsViewModel];
			return {
				name: data.promptName + "\n" + localeDate(data.date),
				value: value != null ? Number(value) : null,
				link: scoreReportEssayLink(data.essayId),
			};
		});
		return data.find((d) => d.value !== null) ? data : [];
	};

	const getAverage = (filter: TraitChartFilter) => {
		return props.averages[filter.value as keyof EssayTraitScoreViewModel];
	};

	const [selected, setSelected] = useState(essayTraits[0]);

	useEffect(() => {
		const trait = essayTraits.find((t) => t.value === selected.value) ?? essayTraits[0];
		setSelected(trait);
	}, [selected]);

	const options: EChartsOption = {
		xAxis: {
			name: `${selected.label} Score`,
		},
	};

	if (!props.scores || props.scores.length == 0) return "";

	return (
		<div className={props.className ?? ""}>
			<SimpleListbox
				id="viewFilter"
				options={essayOptions}
				value={selected.value}
				className="w-1/5"
				onChange={(e) =>
					setSelected(
						essayTraits.find((t) => t.value === e.target.value) ?? essayTraits[0]
					)
				}
			/>

			<TraitScoreEChart
				data={getData(selected)}
				dataLabel={selected.label}
				average={getAverage(selected)}
				averageLabel="Student"
				maxValue={selected.maxValue}
				options={options}
			/>
		</div>
	);
}
